import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/image/learningportal.svg';
import { useRegisterMutation } from '../features/auth/authApi';


const Register = () => {
  const [userData, setUserData]=useState({});
  const handleChangeInput=(event)=>{
    const {name,value}=event.target;
    setUserData(prev=>({...prev,[name]:value}))
  }
  const [registerFunc,{isLoading,data,isSuccess,isError,error}] =useRegisterMutation();
  const handleSubmit =(e)=>{
    e.preventDefault();
    const {confirmpassword,...rest}=userData;
    registerFunc({...rest,role:'student'})}
const navigate=useNavigate()
useEffect(()=>{
if(!isLoading && isSuccess){
navigate('/student/leaderboard')
}
},[isSuccess])


  return (
  <>
  <section className="py-6 bg-primary h-screen grid place-items-center">
  <div className="mx-auto max-w-md px-5 lg:px-0">
    <div>
      <img className="h-12 mx-auto" src={logo} />
      <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
        Create Your New Account
      </h2>
    </div>
    <form className="mt-8 space-y-6" action="#" method="POST" onSubmit={handleSubmit}>
      <input type="hidden" name="remember" defaultValue="true" />
      <div className="rounded-md shadow-sm -space-y-px">
        <div>
          <label htmlFor="name" className="sr-only">Name</label>
          <input onChange={handleChangeInput}  id="name" name="name" type="name" autoComplete="name" required className="login-input rounded-t-md" placeholder="Student Name" />
        </div>
        <div>
          <label htmlFor="email-address" className="sr-only">Email address</label>
          <input onChange={handleChangeInput}  id="email-address" name="email" type="email" autoComplete="email" required className="login-input " placeholder="Email address" />
        </div>
        <div>
          <label htmlFor="password" className="sr-only">Password</label>
          <input onChange={handleChangeInput}  id="password" name="password" type="password" autoComplete="current-password" required className="login-input" placeholder="Password" />
        </div>
        <div>
          <label htmlFor="confirm-password" className="sr-only">Confirm Password</label>
          <input onChange={handleChangeInput}  id="confirm-password" name="confirmpassword" type="password" autoComplete="confirm-password" required className="login-input rounded-b-md" placeholder="Confirm Password" />
        </div>
      </div>
      <div>
        <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
          Create Account
        </button>
    <Link to={'/'}> Login</Link>

      </div>
    </form>
  </div>
</section>

  </>
  )
}

export default Register